import { createProvider } from '@nvision/services/data-provider';

import type { CargoTypeFilters } from '../../models';
import * as api from './api';
import { normalizeCargoTypeFilters, normalizeCargoTypes } from './normalize';

export const fetchCargoTypes = createProvider(
  (filters: Partial<CargoTypeFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchCargoTypes(normalizeCargoTypeFilters(filters), { signal }),
).andThen((res) => normalizeCargoTypes(res));
